// extracted by mini-css-extract-plugin
export default {"container":"Home_container__MGYYT","titleHome":"Home_titleHome__OcQ1r","infoText":"Home_infoText__suZgB","warningText":"Home_warningText__m3MJX","btnPlay":"Home_btnPlay__fBvc8"};